// Rough implementation. Untested.
export const timeout = (ms, promise) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error("timeout"))
    }, ms)
    promise.then(resolve, reject)
  })
}

export const in_array = (item, array) => array.indexOf(item) !== -1 ?
  true : false;

export const query = params => {
  return Object.keys(params)
    .map(k =>
      encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    )
    .join('&');
}

export const attributeFallbackSorter = (attr, fallback) => {
  return (a, b) => {
    if (a[attr] < b[attr]) {
      return -1;
    }
    if (a[attr] > b[attr]) {
      return 1;
    }
    return fallback(a, b);
  }
}

export const attributeSorter = attr => {
  return (a, b) => {
    if (a[attr] < b[attr]) {
      return -1;
    }
    if (a[attr] > b[attr]) {
      return 1;
    }
    return 0;
  }
}

export const nameSorter = attributeSorter('name')

export const companyNameMacSorter = attributeFallbackSorter('company',
  attributeFallbackSorter('name', attributeSorter('mac_address')))



// WEBPACK FOOTER //
// ./src/utils.js